import { UnitFullName } from './UnitFullName.model';
import { UnitPhone } from './UnitPhone.model';

export class UnitBusinessContact
{
  public fullName: UnitFullName;
  public email: string;
  public phone: UnitPhone;
}
